import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class BillingService {
  constructor(private http: HttpClient, public loginService: LoginService) {}

  produceInvoice(invoiceForm: any, currentPatient: any, cancellationForm: any = null): Observable<any> {
    const body = {
      invoiceForm: invoiceForm.value,
      patientDetails: currentPatient,
    };

    return this.http.post(`/api/billing/invoices`, body).pipe(catchError(this.handleError));
  }

  previewDocument(invoiceForm: any, currentPatient: any, cancellationForm: any = null): Observable<any> {
    const body = {
      invoiceForm: invoiceForm.value,
      patientDetails: currentPatient,
    };

    return this.http.post(`/api/billing/invoices/preview`, body).pipe(catchError(this.handleError));
  }

  produceCreditInvoice(selectedInvoice: any, cancellationForm: any, currentPatient: any) {
    const body = {
      selectedInvoice: selectedInvoice,
      cancellationForm: cancellationForm.value,
      patientDetails: currentPatient,
    };
    return this.http.post(`/api/billing/invoices/cancel/credit`, body).pipe(catchError(this.handleError));
  }

  produceCancelReceipt(selectedInvoice: any, cancellationForm: any, currentPatient: any) {
    const body = {
      selectedInvoice: selectedInvoice,
      cancellationForm: cancellationForm.value,
      patientDetails: currentPatient,
    };

    return this.http.post(`/api/billing/invoices/cancel/receipt`, body).pipe(catchError(this.handleError));
  }

  produceCancelCreditReceipt(selectedInvoice: any, cancellationForm: any, currentPatient: any) {
    const body = {
      selectedInvoice: selectedInvoice,
      cancellationForm: cancellationForm.value,
      patientDetails: currentPatient,
    };

    return this.http.post(`/api/billing/invoices/cancel/credit-receipt`, body).pipe(catchError(this.handleError));
  }

  getInvoices(PID: any) {
    return this.http.get(`/api/billing/invoices?PID=${PID}`);
  }

  originDocumentViewed(invoiceIndex: number) {
    const body = { invoiceIndex };
    return this.http.put(`/api/billing/invoices`, body).pipe(catchError(this.handleError));
  }

  closeInvoice(invoiceIndex: number, documentID: string) {
    const body = { invoiceIndex };
    return this.http.put(`/api/billing/invoices/${documentID}/close`, body).pipe(catchError(this.handleError));
  }

  getTodaysFirstAppointment(PID: any): Observable<any> {
    return this.http.get(`/api/billing/invoices/first-appointment/${PID}`).pipe(catchError(this.handleError));
  }

  // getTodaysFirstExam(PID: any): Observable<any> {
  //   return this.http.get(`/api/billing/invoices/first-exam/${PID}`).pipe(catchError(this.handleError));
  // }

  private handleError(error: any): Observable<never> {
    console.error("An error occurred:", error);
    return throwError(error);
  }

  billingReports(params: any): Observable<any> {
    const { doctorUID, documentType, fromDate, toDate } = params;

    // Construct query string
    const queryParams = new URLSearchParams({
      doctorUID: doctorUID || "",
      documentType: documentType || "",
      fromDate: fromDate || "",
      toDate: toDate || "",
    }).toString();

    return this.http.get(`/api/billing/reports?${queryParams}`).pipe(catchError(this.handleError));
  }

  checkReports(params: any): Observable<any> {
    const { doctorUID, documentType, fromDate, toDate } = params;

    // Construct query string
    const queryParams = new URLSearchParams({
      doctorUID: doctorUID || "",
      documentType: documentType || "",
      fromDate: fromDate || "",
     
    }).toString();

    return this.http.get(`/api/billing/checks?${queryParams}`).pipe(catchError(this.handleError));
  }

  searchChecks(params: any): Observable<any> {
    const { doctorUID, fromDate, invoices, collectable, toDate } = params;

    // Construct query string
    const queryParams = new URLSearchParams({
      doctorUID: doctorUID || "",
      fromDate: fromDate || "",
      hasInvoice: invoices,
      canCollect: collectable,
      untilDate: toDate
    }).toString();

    return this.http.get(`/api/billing/checks?${queryParams}`).pipe(catchError(this.handleError));
  }

  makeInvoiceFromCheck(recieptid, checkid){
    return this.http.post('/api/billing/invoicefromcheck',{'recieptid': recieptid, 'checkid': checkid}).pipe(catchError(this.handleError));
  }

  // Get uninvoiced checks for a specific receipt
  getReceiptChecks(receiptAutoIndex: number): Observable<any> {
    return this.http.get(`/api/billing/receipt/${receiptAutoIndex}/checks`).pipe(catchError(this.handleError));
  }

  // Generate invoice from single check
  produceInvoiceFromCheck(receiptId: number, checkId: number): Observable<any> {
    return this.http.post(`/api/billing/invoicefromcheck`, { recieptid: receiptId, checkid: checkId }).pipe(catchError(this.handleError));
  }

  sendEmail(documentID: string, email: string, docUID: number): Observable<any> {
    return this.http.post(`/api/billing/invoices/send-email`, { documentID, email, docUID }).pipe(catchError(this.handleError));
  }
}


